import { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import environmentVariables from "shared/enviromentVariables/index.js.erb";
import { connect } from "react-redux";
import { isOpenRemunerationPlan } from "shared/plans";

class Footer extends Component {
  render() {
    const openRemUser = isOpenRemunerationPlan(this.props.current_user);
    return (
      <footer
        className="page-footer font-small mdb-color"
        style={{
          width: "100%",
          justifyContent: "space-between",
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          paddingRight: "48px",
          flexWrap: "wrap", // Allow wrapping on small screens
          gap: "16px", // Add gap between wrapped items
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: "200px", // Prevent too much shrinking
          }}
        >
          {!openRemUser && (
            <small>
              {environmentVariables.app_name} © {new Date().getFullYear()}
            </small>
          )}
          {openRemUser && (
            <small>
              {environmentVariables.open_rem_app_name} ©{" "}
              {new Date().getFullYear()}
            </small>
          )}
        </div>
        <div
          style={{
            minWidth: "200px", // Prevent too much shrinking
            textAlign: "center",
          }}
        >
          {" "}
          <small>
            Researcher? Contact us @&nbsp;
            {!openRemUser && (
              <a href={`mailto:${environmentVariables.info_email}`}>
                {environmentVariables.info_email}
              </a>
            )}
            {openRemUser && (
              <a href={`mailto:${environmentVariables.open_rem_email}`}>
                {environmentVariables.open_rem_email}
              </a>
            )}
          </small>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap", // Allow links to wrap
            justifyContent: "center",
          }}
        >
          {" "}
          <small>
            <a
              href="#"
              className=""
              onClick={() => window.open("/methodology.pdf", "_blank")}
            >
              Methodology
            </a>
          </small>
          <small>
            <a
              href="#"
              className=""
              onClick={() => window.open("/privacy-policy.pdf", "_blank")}
            >
              Privacy Policy
            </a>
          </small>
          <small>
            <a
              href="#"
              className=""
              onClick={() => window.open("/terms.pdf", "_blank")}
            >
              Terms of Services
            </a>
          </small>
        </div>
      </footer>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;

  return {
    current_user: users.user,
  };
}

export default connect(mapStateToProps, null)(Footer);
